import { useContext, useEffect, useState } from 'react';
import { MainContext } from '../../contexts/main';
import { getPendingRenewal } from '../../helpers/api';
import { useRenewalRetry } from '../../hooks/useRenewalRetry';
import { renewalErrorText } from '../../helpers/renewal';
import { BlockNotifications } from '../blocks/BlockNotifications';
import { BlockRenewalNotice } from '../blocks/BlockRenewalNotice';
import { BlockRenewalRetry } from '../blocks/BlockRenewalRetry';
import { BlockTitle } from '../blocks/BlockTitle';
import { ScreenLoading } from './ScreenLoading';
import { ModalLicense } from '../modals/ModalLicense';

const ScreenRenewalPayerMain = () => {

    const { mainReducer, appReducer } = useContext( MainContext );

    const renewal = useRenewalRetry({ payerMode: true });

    const pendingRenewal = mainReducer.state.pendingRenewal;

    useEffect(() => {
        if ((pendingRenewal === false) && (renewal.result === false) && (renewal.status == 'idle')) {
            appReducer.dispatch({
                type: 'setNotifications',
                payload: [{
                    type: 'error',
                    content: renewalErrorText(['renewal_not_pending'])
                }]
            });
        }
    }, []);

    if (renewal.status == 'redirecting') {
        return <ScreenLoading text="redirigiendo_pasarela" />;
    }

    if (renewal.status != 'idle') {
        return <ScreenLoading text="renewal_checking" />;
    }

    return  <main className="e__plns__opt">
                <BlockTitle title="renewal_payer_page_title" />
                <BlockRenewalNotice renewal={ renewal } payerMode={ true } />
                <BlockNotifications />
                {((pendingRenewal !== false) && (!pendingRenewal.sepaInProgress)) &&
                    <BlockRenewalRetry renewal={ renewal } payerMode={ true } />
                }
                {appReducer.state.modals.license && <ModalLicense />}
            </main>;
}

export const ScreenRenewalPayer = () => {

    const { environment, mainReducer } = useContext( MainContext );

    const [ stateLoaded, setStateLoaded ] = useState(false);

    useEffect(() => {
        getPendingRenewal({ environment: environment.entorno }).then(response => {
            mainReducer.dispatch({
                type: 'setRenewalPayer',
                payload: response.pendingRenewal ?? false
            });
            setStateLoaded(true);
        });
    }, []);

    if (!stateLoaded) {
        return <ScreenLoading />;
    }

    return <ScreenRenewalPayerMain />;
}
